// **************** ROUTE CONSTANT START **************************
// General Page Section
export const DASHBOARD = '/'
export const BOARDS = '/boards'
export const POS = '/pos'
export const RAFFLES = '/raffles'
export const PRODUCTS = '/products'
export const CATEGORY = '/category'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const ORDERS = '/orders'
export const CUSTOMERS = '/customers'
export const COUPONS = '/coupons'
export const SETTINGS = '/settings'
export const STAFF_MEMBERS = '/staff-members'
export const SITE_SETTINGS = '/site-settings'
export const RAFFLE_GAME = '/lanzar-sorteo'
export const EXPOSITORES = '/expositores'
export const CREDENCIALES = '/expositores/:id/credenciales'
export const EXPOSITORESFICHA = '/expositores/:id/ficha'
export const EXPOSITORESCREDENCIALES = '/credenciales'
export const PREREGISTRO = '/preregistro'
export const PREREGISTRODETALLE = '/preregistro/:id'
export const CHECKIN = '/checkin'
export const TICKETS = '/tickets'
// **************** ROUTE CONSTANT END **************************

export const CURRENCY = '$'
export const zoneOptions = [
    {
        label: 'PABELLÓN UNO',
        id: 'PABELLON_UNO',
    },
    {
        label: 'PABELLÓN DOS',
        id: 'PABELLON_DOS',
    },
    {
        label: 'PATIO PRINCIPAL - TARIMA',
        id: 'PATIO_PRINCIPAL',
    },
    // {
    //     label: 'PABELLÓN EMPRENDEDOR',
    //     id: 'PABELLON_EMPRENDEDOR',
    // },
    // {
    //     label: 'PLAZA GASTRONÓMICA',
    //     id: 'PLAZA_GASTRONOMICA',
    // },
    // {
    //     label: 'PLAZA DE DULCES',
    //     id: 'PLAZA_DE_DULCES',
    // },
    // {
    //     label: 'ÁREA INFANTIL',
    //     id: 'AREA_INFANTIL',
    // },
    // {
    //     label: 'PARQUE MECÁNICO',
    //     id: 'PARQUE_MECANICO',
    // },
    {
        label: 'ZONA GASTRO-BAR',
        id: 'ZONA_GASTO_BAR',
    },
    // {
    //     label: 'PABELLÓN ALTERNO',
    //     id: 'PABELLON_ALTERNO',
    // },
    {
        label: 'OTROS',
        id: 'OTROS',
    },
]
